import { mapEvents, mapLiveGameState, mapGameScore } from "./mapEvent";
import { mapArrayElement } from "../../../helpers";
import { mapBet } from "./mapBet";
import { mapCashout, mapInformationMessage, mapOperationsPull, mapOperationResult } from "./mapCashout";
export function mapInitialResponse(response) {
    const [data] = response.data;
    const [betsArray, eventsMap, cashOut] = data;
    return {
        bets: mapBet(betsArray),
        events: mapEvents(eventsMap),
        cashOut: mapCashout(cashOut)
    };
}
export function mapNextBetsPageResponse(response) {
    const [betsArray, eventsMap] = response.data;
    return {
        bets: mapBet(betsArray),
        events: mapEvents(eventsMap),
        cashOut: {
            informations: {},
            operations: {}
        }
    };
}
export function mapUpdateResponse(response) {
    return Object.assign(Object.assign(Object.assign({}, mapEventUpdate(response.data[1])), { legTrackingUpdate: mapLegTrackingUpdate(response.data[2]) }), mapCashOutUpdate(response.data[4]));
}
export function mapCashoutOperationPull(response) {
    const data = response.data;
    const pullOperations = data[2] ? {
        subscribed: data[2],
    } : {
        initial: mapOperationsPull(data[0])
    };
    return Object.assign({}, pullOperations);
}
export function mapEventUpdate(response) {
    if (response) {
        const update = response[0];
        const remove = update[1];
        const change = update[2][0];
        return {
            eventsUpdate: {
                data: {
                    add: {
                        events: []
                    },
                    change: {
                        events: change.map(data => ({
                            id: data[0],
                            status: data[1],
                            score: mapArrayElement(data[2], mapGameScore),
                            isLive: data[3],
                            liveGameState: mapArrayElement(data[4], mapLiveGameState),
                            startEventDate: data[5],
                        })),
                    },
                    remove: {
                        events: remove.map(el => el[0])
                    }
                }
            }
        };
    }
    return {
        eventsUpdate: {
            data: {
                add: {
                    events: []
                },
                change: {
                    events: []
                },
                remove: {
                    events: []
                }
            }
        }
    };
}
export function mapCashOutUpdate(data) {
    if (data) {
        return {
            cashOutUpdate: mapInformationMessage(data),
        };
    }
    return {};
}
export function mapLegTrackingUpdate(response) {
    if (response) {
        return response.map(data => ({
            eventId: data[0],
            marketId: data[1],
            totalPoints: data[2]
        }));
    }
    return [];
}
export function cashoutOperationsUpdate(response) {
    const data = response.data;
    if (data[1]) {
        return {
            cashOutOperationResultUpdate: mapOperationResult(data[1]),
        };
    }
    return {};
}
export const proxyMsgPackMapper = (mapper, data) => () => mapper(data);
//# sourceMappingURL=mapResponses.js.map